.ModalPopup .titlePanel {
  color: white;
  padding: 15px;
  text-transform: uppercase;
}
.ModalPopup hr {
  margin-top: 20px;
  margin-bottom: 20px;
}

.modal-content {
  padding: 0;
}
.modal-content .contentPanel {
  padding: 1.2rem;
}
.modal-content .contentPanel .actions {
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 500px) {
  .ModalPopup {
    width: 100% !important;
  }
  .modal-content .contentPanel {
    padding: 10px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvanRyZW1ibGF5L3NvbHV0aW9uc3RsbS50aWNrZXRpbmdzeXN0ZW0vc3JjL3RzLmludGVybmV0c2FsZS4zLjAvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvbW9sZWN1bGVzIiwic291cmNlcyI6WyJtb2RhbC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNJO0VBQ0k7RUFDQTtFQUNBOztBQUdKO0VBQ0k7RUFDQTs7O0FBSVI7RUFDSTs7QUFFQTtFQUNJOztBQUVBO0VBQ0k7RUFDQTs7O0FBS1o7RUFDSTtJQUNJOztFQUlBO0lBQ0kiLCJzb3VyY2VzQ29udGVudCI6WyIuTW9kYWxQb3B1cCB7XG4gICAgLnRpdGxlUGFuZWwge1xuICAgICAgICBjb2xvcjogd2hpdGU7XG4gICAgICAgIHBhZGRpbmc6IDE1cHg7XG4gICAgICAgIHRleHQtdHJhbnNmb3JtOiB1cHBlcmNhc2U7XG4gICAgfVxuXG4gICAgaHIge1xuICAgICAgICBtYXJnaW4tdG9wOiAyMHB4O1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAyMHB4O1xuICAgIH1cbn1cblxuLm1vZGFsLWNvbnRlbnQge1xuICAgIHBhZGRpbmc6IDA7XG5cbiAgICAuY29udGVudFBhbmVsIHtcbiAgICAgICAgcGFkZGluZzogMS4ycmVtO1xuXG4gICAgICAgIC5hY3Rpb25zIHtcbiAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgfVxuICAgIH1cbn1cblxuQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogNTAwcHgpIHtcbiAgICAuTW9kYWxQb3B1cCB7XG4gICAgICAgIHdpZHRoOiAxMDAlIWltcG9ydGFudDtcbiAgICB9XG5cbiAgICAubW9kYWwtY29udGVudCB7XG4gICAgICAgIC5jb250ZW50UGFuZWwge1xuICAgICAgICAgICAgcGFkZGluZzogMTBweDtcbiAgICAgICAgfVxuICAgIH1cbn1cbiJdfQ== */